import { environment } from '@environments/environment';
import { Banner } from '../models/assets.model';
import { Theming, ThemingService } from '../services/theming.service';

export const FONTS_TO_LOAD: readonly string[] = [
  '1em Signika',
  '1em Signika light',
  '1em Signika semibold',
  '1em Signika bold',
  '1em Genica',
  '1em Museo Sans Rounded-900',
  '1em Museo Sans Rounded-1000',
  '1em Ubuntu',
  '1em Ubuntu medium',
  '1em Ubuntu bold',
  '1em Passion One',
  '1em Passion One Bold',
] as const;

export const PreloadAssets = {
  getTrophiesImages(): readonly string[] {
    return ['content/images/shared/check_2.webp'];
  },

  getLobbyImages(themingService: ThemingService): readonly string[] {
    return [
      'content/images/home/nav/buy-button-hover-1.png',
      'content/images/home/nav/buy-button-idle-1.png',
      'content/images/home/nav/buy-button-clic-1.png',
      'content/images/home/nav/buy-offer-button-1.png',
      'content/images/home/nav/sbuy-button-clic-1.png',
      'content/images/home/nav/sbuy-button-hover-1.png',
      'content/images/home/nav/soffer-button-clic-1.png',
      'content/images/home/nav/soffer-button-hover-1.png',
      'content/images/home/nav/pattern-marquee.png',
      'content/images/home/nav/star.png',
      'content/images/home/nav/New_UI_Footer.png',
      'content/images/home/nav/coin.png',
      'content/images/home/nav/gem.png',
      'content/images/home/nav/bomb.png',
      'content/images/home/nav/Icon_Daily_Challenge.png',
      'content/images/home/nav/Icon_Trofeos.png',
      'content/images/home/nav/Icon_Eventos.png',
      'content/images/home/nav/Icon_Daily_Challenge_blocked.png',
      'content/images/home/nav/Icon_Events_blocked.png',
      'content/images/home/nav/icon-videoads-on.png',
      'content/images/home/nav/icon-videoads-off.png',
      themingService.getThemeAsset('portal', 'lobby-background'),
    ];
  },

  getBanners(banners: Banner[]): readonly string[] {
    return banners.map((b) => `${environment.CDN}${b.assetUrl}`);
  },

  getThemingImages(theming: Theming): readonly string[] {
    return Object.values(theming).flatMap((group) => Object.values(group));
  },

  getAll(themingService: ThemingService, theming: Theming, banners: Banner[]): readonly string[] {
    return [
      ...this.getLobbyImages(themingService),
      ...this.getTrophiesImages(),
      ...this.getBanners(banners),
      ...this.getThemingImages(theming),
    ];
  },
} as const;
